import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { P } from 'sushiweb/Typography/Text';
import { logoutUser } from '../../../../actions/auth';
import { openErrorToast } from '../../../../reducers/uiLogic';
import {
  BalanceDetailsWrapper,
  BalanceWidgetHead,
  BalanceWidgetName,
  BalanceWidgetWrapper,
} from './styles';
import {
  formatAmountInRupees,
  getAvailableWorkspaceLimit,
} from '../../../../helpers';
import { applicableFlowTypes, currentFlowTypeEnum } from '../constants';

const BalanceWidget = ({ selectedWorkspace, currentFlow }) => {
  return (
    <BalanceWidgetWrapper>
      <BalanceWidgetHead>
        <BalanceWidgetName>
          {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT ? (
            <BalanceDetailsWrapper>
              <P> Available Budget: </P>
              {' '}
              <P id='amount'>
                &nbsp;
                {getAvailableWorkspaceLimit(selectedWorkspace)}
              </P>
            </BalanceDetailsWrapper>
          ) : (
            <BalanceDetailsWrapper>
              <P> Current balance: </P>
              {' '}
              <P id='amount'>
                &nbsp;
                {formatAmountInRupees(selectedWorkspace?.balance ?? 0)}
              </P>
            </BalanceDetailsWrapper>
          )}
        </BalanceWidgetName>
      </BalanceWidgetHead>
    </BalanceWidgetWrapper>
  );
};

BalanceWidget.propTypes = {
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
};

BalanceWidget.defaultProps = {
  selectedWorkspace: {},
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
};

const mapDispatchToProps = dispatch => ({
  logUserOut: () => dispatch(logoutUser()),
  showErrorToast: () => dispatch(openErrorToast()),
});

export default connect(
  null,
  mapDispatchToProps,
)(BalanceWidget);
